import React from 'react';

import './Spin.global.styl';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  spinning: boolean;
  className: string;
}

function Spin({ children, spinning, className, ...props }: Props) {
  return (
    <div {...props} className={`mio-spin ${className}`}>
      <div className={`mio-spin__spinner ${spinning ? 'visible' : ''}`} />
      {children}
    </div>
  );
}

Spin.defaultProps = {
  children: [],
  spinning: false,
  className: '',
} as Partial<Props>;

export default Spin;
